import { getBuyerId } from 'dibs-cookie-jar';
import serverVars from 'server-vars';

import { sendAnalyticsData } from './perfAnalyticsHelpers.ts';
import { getForwardedHost } from './helpers.ts';

export const trackClientError = ({
    rumTransactionName,
    monitoringGroupName,
    errorMessage,
    errorName,
    errorStack,
    level,
}: {
    rumTransactionName?: string;
    monitoringGroupName?: string;
    errorMessage?: string;
    errorName?: string;
    errorStack?: string;
    level?: 'info' | 'warn' | 'error';
}): void => {
    /**
     * Prevent local devboxes from sending client errors to the server.
     */
    if (process.env.NODE_ENV !== 'production') {
        return;
    }
    const payload = {
        rumTransactionName: rumTransactionName || serverVars.get('rumTransactionName') || 'unknown',
        monitoringGroupName:
            monitoringGroupName || serverVars.get('monitoringGroupName') || 'unknown',
        forwardedHost: getForwardedHost(),
        clientUrl: location.href,
        clientUserId: getBuyerId(document.cookie) || undefined,
        errorMessage: errorMessage || 'unknown',
        errorName: errorName || 'unknown',
        errorStack: errorStack || 'unknown',
        appVersion: serverVars.get('appVersion') || `0.0.0`,
        deviceType: serverVars.get('settings.deviceType'),
        level,
    };

    sendAnalyticsData(
        `${location.protocol}//${location.host}/soa/client-analytics/error/`,
        payload
    );
};
